// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as N2f$Linear from "lumi-linear/lib/es6/src/N2f.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as M23f$Linear from "lumi-linear/lib/es6/src/M23f.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PlaceClass$LumiDocuments from "./PlaceClass.res.js";

import '../../../src/css/place-model.scss'
;

function up(param, placeClass) {
  let up$1 = param.up;
  if (typeof placeClass !== "object" && placeClass === "PlaceClassVertical") {
    return N2f$Linear.normalize(V2f$Linear.minus(param.baseBack, param.baseFront));
  } else {
    return up$1;
  }
}

function transform(param, hmirror, vflip, param$1) {
  let height = param[1];
  let width = param[0];
  let transformAbs = param => {
    let y = param[1];
    let x = param[0];
    return [
      hmirror ? width - x : x,
      vflip ? height - y : y
    ];
  };
  let transformRel = param => {
    let y = param[1];
    let x = param[0];
    return [
      hmirror ? -1 * x : x,
      vflip ? -1 * y : y
    ];
  };
  return {
    baseFront: transformAbs(param$1.baseFront),
    baseBack: transformAbs(param$1.baseBack),
    up: Stdlib_Option.map(param$1.up, n2 => N2f$Linear.map(n2, transformRel)),
    side: transformAbs(param$1.side),
    sideLength: param$1.sideLength
  };
}

function warpAffine(am, m23) {
  return {
    baseFront: M23f$Linear.Mult.v2f(m23, am.baseFront),
    baseBack: M23f$Linear.Mult.v2f(m23, am.baseBack),
    up: Stdlib_Option.map(am.up, up => M23f$Linear.Mult.n2f(m23, up)),
    side: M23f$Linear.Mult.v2f(m23, am.side),
    sideLength: am.sideLength
  };
}

function elongateBase(am, s) {
  let frontToBack = V2f$Linear.minus(am.baseBack, am.baseFront);
  let baseMid = V2f$Linear.plus(am.baseFront, V2f$Linear.scale(frontToBack, 0.5));
  let midToFront = V2f$Linear.minus(am.baseFront, baseMid);
  let midToBack = V2f$Linear.minus(am.baseBack, baseMid);
  let front$p = V2f$Linear.plus(baseMid, V2f$Linear.scale(midToFront, s));
  let back$p = V2f$Linear.plus(baseMid, V2f$Linear.scale(midToBack, s));
  return {
    baseFront: front$p,
    baseBack: back$p,
    up: am.up,
    side: am.side,
    sideLength: am.sideLength
  };
}

let jsonCodec = Jzon.object5(param => [
  param.baseFront,
  param.baseBack,
  param.up,
  param.side,
  param.sideLength
], param => ({
  TAG: "Ok",
  _0: {
    baseFront: param[0],
    baseBack: param[1],
    up: param[2],
    side: param[3],
    sideLength: param[4]
  }
}), Jzon.field("baseFront", V2f$Linear.jsonCodec), Jzon.field("baseBack", V2f$Linear.jsonCodec), Jzon.field("up", Jzon.nullable(N2f$Linear.jsonCodec)), Jzon.field("side", V2f$Linear.jsonCodec), Jzon.field("sideLength", Jzon.float));

function getScale(param) {
  return V2f$Linear.length(V2f$Linear.minus(param.side, param.baseFront)) / param.sideLength;
}

function toPoly(placeModel, placeClass) {
  let up = placeModel.up;
  let baseBack = placeModel.baseBack;
  let baseFront = placeModel.baseFront;
  let pxPerM = getScale(placeModel);
  let dimensions = PlaceClass$LumiDocuments.PlaceClass.axesModelDimensions(placeClass);
  if (up !== undefined) {
    let normBase = V2f$Linear.scaleTo(V2f$Linear.minus(baseBack, baseFront), 1);
    let perpCW = V2f$Linear.perpendicularCW(normBase);
    let perpBack = V2f$Linear.scale(perpCW, 0.5 * dimensions.widthBack * pxPerM);
    let perpFront = V2f$Linear.scale(perpCW, 0.5 * dimensions.widthFront * pxPerM);
    let upBack = V2f$Linear.scaleTo(N2f$Linear.asV2f(up), 0.5 * dimensions.heightBack * pxPerM);
    let upFront = V2f$Linear.scaleTo(N2f$Linear.asV2f(up), 0.5 * dimensions.heightFront * pxPerM);
    let front = V2f$Linear.minus(baseFront, V2f$Linear.scale(normBase, dimensions.baseFrontExtra * pxPerM));
    let back = V2f$Linear.plus(baseBack, V2f$Linear.scale(normBase, dimensions.baseBackExtra * pxPerM));
    return {
      topLeft: V2f$Linear.plus(V2f$Linear.plus(back, perpBack), upBack),
      bottomLeft: V2f$Linear.plus(V2f$Linear.plus(front, perpFront), upFront),
      bottomRight: V2f$Linear.plus(V2f$Linear.minus(front, perpFront), upFront),
      topRight: V2f$Linear.plus(V2f$Linear.minus(back, perpBack), upBack)
    };
  }
  let halfFrontWidth = V2f$Linear.scaleTo(V2f$Linear.minus(placeModel.side, baseFront), 0.5 * dimensions.widthFront * pxPerM);
  return {
    topLeft: V2f$Linear.plus(baseBack, halfFrontWidth),
    bottomLeft: V2f$Linear.plus(baseFront, halfFrontWidth),
    bottomRight: V2f$Linear.minus(baseFront, halfFrontWidth),
    topRight: V2f$Linear.minus(baseBack, halfFrontWidth)
  };
}

function extraPoints(param) {
  return [
    param.baseFront,
    param.baseBack
  ];
}

function mainPoint(param) {
  return param.baseFront;
}

function scale(baseFront, side, sideLength) {
  return V2f$Linear.length(V2f$Linear.minus(side, baseFront)) / sideLength;
}

function AxesModel$Svg$Base(props) {
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let className = LumiReact.classList([[
      "place-model-base",
      true
    ]].concat(classList));
  let match = V2f$Linear.mapToString(props.baseFront);
  let match$1 = V2f$Linear.mapToString(props.baseBack);
  return JsxRuntime.jsx("line", {
    className: className,
    vectorEffect: "non-scaling-stroke",
    x1: match[0],
    x2: match$1[0],
    y1: match[1],
    y2: match$1[1]
  });
}

let Base = {
  make: AxesModel$Svg$Base
};

function AxesModel$Svg$Side(props) {
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let className = LumiReact.classList([[
      "place-model-side",
      true
    ]].concat(classList));
  let match = V2f$Linear.mapToString(props.baseFront);
  let match$1 = V2f$Linear.mapToString(props.side);
  return JsxRuntime.jsx("line", {
    className: className,
    vectorEffect: "non-scaling-stroke",
    x1: match[0],
    x2: match$1[0],
    y1: match[1],
    y2: match$1[1]
  });
}

let Side = {
  make: AxesModel$Svg$Side
};

function AxesModel$Svg$Up(props) {
  let __classList = props.classList;
  let baseFront = props.baseFront;
  let classList = __classList !== undefined ? __classList : [];
  let scale$1 = scale(baseFront, props.side, props.sideLength);
  let absoluteUp = V2f$Linear.plus(baseFront, V2f$Linear.scaleTo(N2f$Linear.asV2f(props.up), scale$1 * 0.5));
  let className = LumiReact.classList([[
      "place-model-up",
      true
    ]].concat(classList));
  let match = V2f$Linear.mapToString(baseFront);
  let match$1 = V2f$Linear.mapToString(absoluteUp);
  return JsxRuntime.jsx("line", {
    className: className,
    vectorEffect: "non-scaling-stroke",
    x1: match[0],
    x2: match$1[0],
    y1: match[1],
    y2: match$1[1]
  });
}

let Up = {
  make: AxesModel$Svg$Up
};

function AxesModel$Svg(props) {
  let __upClassList = props.upClassList;
  let __sideClassList = props.sideClassList;
  let __baseClassList = props.baseClassList;
  let match = props.axesModel;
  let sideLength = match.sideLength;
  let side = match.side;
  let baseBack = match.baseBack;
  let baseFront = match.baseFront;
  let baseClassList = __baseClassList !== undefined ? __baseClassList : [];
  let sideClassList = __sideClassList !== undefined ? __sideClassList : [];
  let upClassList = __upClassList !== undefined ? __upClassList : [];
  let match$1 = V2f$Linear.mapToString(baseFront);
  let match$2 = V2f$Linear.mapToString(baseBack);
  return JsxRuntime.jsxs("g", {
    children: [
      JsxRuntime.jsx("line", {
        className: "place-model-click-target",
        vectorEffect: "non-scaling-stroke",
        x1: match$1[0],
        x2: match$2[0],
        y1: match$1[1],
        y2: match$2[1]
      }),
      JsxRuntime.jsx(AxesModel$Svg$Base, {
        baseFront: baseFront,
        baseBack: baseBack,
        classList: baseClassList
      }),
      JsxRuntime.jsx(AxesModel$Svg$Side, {
        baseFront: baseFront,
        side: side,
        classList: sideClassList
      }),
      LumiReact.renderOption(undefined, match.up, up => JsxRuntime.jsx(AxesModel$Svg$Up, {
        baseFront: baseFront,
        side: side,
        sideLength: sideLength,
        up: up,
        classList: upClassList
      }))
    ],
    className: "axes-model"
  });
}

let Svg = {
  scale: scale,
  Base: Base,
  Side: Side,
  Up: Up,
  make: AxesModel$Svg
};

export {
  up,
  transform,
  warpAffine,
  elongateBase,
  jsonCodec,
  getScale,
  toPoly,
  extraPoints,
  mainPoint,
  Svg,
}
/*  Not a pure module */
